import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';

@Component({
  selector: 'modal-presupuestos-estados',
  templateUrl: './modal-presupuestos-estados.component.html',
  styleUrls: ['./modal-presupuestos-estados.component.scss']
})
export class ModalPresupuestosEstadosComponent implements OnInit {

  @ViewChild('modalPresupuestosEstado')
  public modalPresupuestosEstado: any;
  public modalActivo: NgbModalRef;
  public datosPresupuestos: any[];
  public obraSeleccionada: ObraDTO;
  public mostrarFicha: boolean = false;

  constructor(private modalService: NgbModal,
    private pdfUtils: PdfUtils) { }

  ngOnInit() {
  }

  public abrirlModalPresupuestos(datosPresupuestos: any): void {
    this.datosPresupuestos = datosPresupuestos;
    this.modalActivo = this.modalService.open(this.modalPresupuestosEstado, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public descargarPDF(): void {
    this.pdfUtils.descargarPresupuestosEstado();
  }

  public descargar(): void {
    if (this.obraSeleccionada.obra.incluyeImagenes) {
      // this.pdfUtils.descargarPdf(); //COMENTADA PORQUE AUN NO HAY IMAGENES
      this.pdfUtils.descargarFichaSinImagenes();
    } else {
      this.pdfUtils.descargarFichaSinImagenes();
    }
  }

  public mostrarFichaTecnica(obraRecibida) {
    this.obraSeleccionada = obraRecibida;
    this.mostrarFicha = true;
  }

  public regresar() {
    this.obraSeleccionada = null;
    this.mostrarFicha = false;
  }

}
